import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/LoginPage.css';

const LoginPage: React.FC = () => {
  const { login } = useAuth();

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Azure SQL Manager</h1>
        <p className="login-subtitle">Database Management Tool</p>

        <div className="login-content">
          <p>Please sign in with your organizational account to access the application.</p>

          <button className="login-button" onClick={login}>
            Sign in with Microsoft
          </button>
        </div>

        <div className="login-footer">
          <p>Authorized users only</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;